import React from 'react';
import { Language, View } from '../../types';

interface FooterProps {
  lang: Language;
  setView?: (v: View) => void;
}

const Footer: React.FC<FooterProps> = ({ lang, setView }) => {
  const footerLinks = [
    { label: { en: 'Journey', fa: 'سفر' }, view: 'journey' as View },
    { label: { en: 'About', fa: 'درباره من' }, view: 'about' as View },
    { label: { en: 'Process', fa: 'فرایند' }, view: 'impact' as View },
    { label: { en: 'Approach', fa: 'رویکرد' }, view: 'approach' as View },
  ];

  const handleNavClick = (view: View) => {
    if (setView) {
      setView(view);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-50 border-t border-gray-100 py-12">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <h3 className="text-xl font-bold text-brandDark mb-3">
              Kayvan <span className="text-primary">Coaching</span>
            </h3>
            <p className="text-sm text-gray-500 leading-relaxed">
              {lang === 'en'
                ? 'Helping you transform inner conflict into clarity and courageous action.'
                : 'کمک می‌کنم تضادهای درونی رو به شفافیت و اقدام شجاعانه تبدیل کنی.'
              }
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-xs uppercase tracking-wider font-bold text-gray-500 mb-3">
              {lang === 'en' ? 'Explore' : 'کاوش'}
            </h4>
            <nav className="space-y-1" aria-label={lang === 'en' ? 'Footer navigation' : 'ناوبری فوتر'}>
              {footerLinks.map((link, i) => (
                <button
                  key={i}
                  onClick={() => handleNavClick(link.view)}
                  className="block text-sm text-gray-600 hover:text-primary transition-colors duration-200 text-left cursor-pointer focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:outline-none rounded min-h-[44px] py-2"
                >
                  {link.label[lang]}
                </button>
              ))}
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs uppercase tracking-wider font-bold text-gray-500 mb-3">
              {lang === 'en' ? 'Get in touch' : 'در تماس باش'}
            </h4>
            <a
              href="mailto:kayvan.coaching@gmail.com"
              className="inline-block text-sm text-primary hover:text-teal-700 hover:underline transition-colors duration-200 focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:outline-none rounded min-h-[44px] py-2"
            >
              kayvan.coaching@gmail.com
            </a>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-gray-100 pt-6 text-xs text-gray-500">
          <p>
            {lang === 'en'
              ? '© 2024 Kayvan Coach. All rights reserved.'
              : '© ۲۰۲۴ کیوان کوچ. تمامی حقوق محفوظ است.'
            }
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
